import { render, staticRenderFns } from "./TabsRouterComponent.vue?vue&type=template&id=497c08c2&"
import script from "./TabsRouterComponent.vue?vue&type=script&lang=js&"
export * from "./TabsRouterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports